import { types } from './types';

export const getCurrentUserLanguage = () => ({
  type: types.GET_CURRENT_USER_LANGUAGE_REQUEST,
});

export const setLandingPageLanguage = (lang: string, loggedIn: boolean) => ({
  lang,
  loggedIn,
  type: types.SET_LANDING_PAGE_LANGUAGE_REQUEST,
});

export const setUserModalLanguage = (lang: string) => ({
  lang,
  type: types.SET_USER_MODAL_LANGUAGE_REQUEST,
});

export const setIsFetchingMessages = (isFetching: boolean) => ({
  payload: isFetching,
  type: types.SET_FETCHING_MESSAGES,
});

export const setIsUserLanguageRerendered = (value: boolean) => ({
  type: types.SET_USER_LANGUAGE_RERENDERED,
  value: value,
});
